import { configureStore } from '@reduxjs/toolkit';
import {
    persistStore, persistReducer, FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import ui from './reducers/ui';
import auth from './reducers/auth';
import academic from './reducers/academic';
import notification from './reducers/notification';


const store = configureStore({
    reducer: {
        ui: persistReducer({
            key: 'ui',
            storage,
        }, ui),
        auth: persistReducer({
            key: 'auth',
            storage,
            blacklist: ['uiMessage']
        }, auth),
        academic: academic,
        notifications: notification
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});


const persistor = persistStore(store);

export { store, persistor };